<h1 class="center">
  Profil
</h1>
<nav>
  <a routerLinkActive="active-link" routerLink="./personal-information">Informations personnelles</a>
  <a routerLinkActive="active-link" routerLink="./password-change">Changement de mot de passe</a>
</nav>
<router-outlet></router-outlet>